import {
    FETCH_ACTIVITIES_REQUEST,
    FETCH_ACTIVITIES_SUCCESS,
    FETCH_ACTIVITIES_FAILURE,
} from '../actions/activitiesActions';

const initialState = {
    list: { data: null, loading: false, error: null },
};

const activitiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ACTIVITIES_REQUEST:
            return { ...state, list: { data: state.list.data, loading: true, error: null } };
        case FETCH_ACTIVITIES_SUCCESS:
            return { ...state, list: { data: action.payload, loading: false, error: null } };
        case FETCH_ACTIVITIES_FAILURE:
            return { ...state, list: { data: null, loading: false, error: action.payload } };
        default:
            return state;
    }
};

export default activitiesReducer;




